var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tour-guide-ringing" },
    [
      _vm.customBranding
        ? _c("div", { staticClass: "tour-guide-portrait" }, [
            _vm.portrait
              ? _c("img", { attrs: { src: _vm.portrait } })
              : _c("i", { staticClass: "isif isif-man" }),
          ])
        : _c("div", { staticClass: "tour-guide-portrait" }, [
            _c("img", { attrs: { src: _vm.iStagingPortrait } }),
          ]),
      _vm._v(" "),
      _c("p", { staticClass: "tour-guide-name" }, [
        _vm._v("\n    " + _vm._s(_vm.name) + "\n  "),
      ]),
      _vm._v(" "),
      _vm.responseText
        ? [
            _c("div", { staticClass: "tour-guide-status" }, [
              _c("p", { staticClass: "tour-guide-status-text" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t(_vm.responseText)) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tourring.response")) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tour-guide-result-btn" }, [
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("showCalendar")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "isif isif-reserve" }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("tourring.goToReserve")) +
                      "\n      "
                  ),
                ]
              ),
            ]),
          ]
        : [
            _c("div", { staticClass: "tour-guide-status" }, [
              _c("p", { staticClass: "tour-guide-status-text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tourring.dialing")) +
                    "\n        "
                ),
                _c("span", { staticClass: "tour-guide-ringing-mark" }, [
                  _vm._v(_vm._s(_vm.ringingMark)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tour-guide-hint" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("tourring.dialingHint")))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tour-guide-ringing-btn" }, [
              _c("button", { on: { click: _vm.openConfrimModal } }, [
                _c("i", { staticClass: "isif isif-phone" }),
              ]),
            ]),
          ],
      _vm._v(" "),
      _c(
        "IModal",
        {
          ref: "confirmModal",
          attrs: { bgcolor: "transparent", closeable: false },
        },
        [
          _c("div", { staticClass: "tour-guide-confirm-modal" }, [
            _c("p", [_vm._v(_vm._s(_vm.formData.name))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("tourring.handupPhoneHint")))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("tourring.handupPhoneHint2")))]),
            _vm._v(" "),
            _c("div", { staticClass: "tour-guide-confirm-action" }, [
              _c(
                "button",
                { staticClass: "cancel", on: { click: _vm.closeConfrimModal } },
                [
                  _c("i", { staticClass: "isif isif-close" }),
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("cancel")) + "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "confirm", on: { click: _vm.hangUpPhone } },
                [
                  _c("i", { staticClass: "isif isif-check" }),
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("confirm")) + "\n        "
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }